import { connect } from 'react-redux';
import { connectRequest } from '../../../utils/query';
import { compose, bindActionCreators } from 'redux';
import { injectIntl } from 'react-intl';

import ChangePlanPage from '../../../components/ChangePlan/motorplay';
import { requestAsync, updateInitialExchangeByDeviceCountry, hiddenCouponInput } from '../../../queries/actions';
import { updatePlanSubscription } from '../../../queries/subscription';
import {
  selectActivePlanSubscription, selectProducts,
  selectProductsPlan,
} from '../../../queries/selectors/products';
import { selectSubscriberConfig, selectSubscriptionList } from '../../../queries/selectors/bootstrap';
import { selectCurrentContentFichaPath } from '../../../queries/selectors/contents';
import { selectUserData } from '../../../queries/selectors/user';
import withMembershipGuard from '../../withMembershipGuard';
import withMembershipPurchased from '../../withMembershipPurchased';
import withAuthGuard from '../../withAuthGuard';
import withPaymentStatus from '../../withPaymentStatus';
import { selectClient, selectProductToUpgrade } from '../../../global-selectors';
import { selectAllSubPaymentMethodsConfig, selectCurrentPaymentMethod } from '../../../queries/selectors/payment';
import { setIgnoreRedirectInSubscription } from '../../../queries/actions/subscriber';
import { addProduct, cleanOrder } from '../../../queries/actions/shoppingCart';
import { getSubPaymentMethodsByClient } from '../../../queries/paymentMethods';
import { setCurrentSubPaymentMethod } from '../../../queries/actions/payment';
import { getAlltransactions } from '../../../queries/transactions';

const mapStateToProps = state => {
  const userData = selectUserData(state);
  return {
    userPlan: selectActivePlanSubscription(state),
    plans: selectProductsPlan(state),
    products: selectProductsPlan(state),
    allProducts: selectProducts(state),
    path: selectCurrentContentFichaPath(state),
    subscriptions: selectSubscriptionList(state),
    methodId: selectCurrentPaymentMethod(state),
    user: userData,
    client: selectClient(state),
    productToUpgradeId: selectProductToUpgrade(state),
    subscriber: selectSubscriberConfig(state),
    subPaymentMethods: selectAllSubPaymentMethodsConfig(state),
    token: userData?.token,
  }
}

const mapDispatchToProps = (
  (dispatch) => bindActionCreators({
    updatePlanSubscription: (data) => requestAsync(updatePlanSubscription, data),
    updateInitialExchangeByDeviceCountry: (payload) => updateInitialExchangeByDeviceCountry(payload),
    setCurrentSubPaymentMethod: payload => dispatch(setCurrentSubPaymentMethod(payload)),
    setIgnoreRedirect: payload => setIgnoreRedirectInSubscription(payload),
    addProduct: payload => addProduct(payload),
    cleanOrder: () => cleanOrder(),
    hiddenCouponInput: (data) => hiddenCouponInput(data),
  }, dispatch)
);

const mapPropsToConfig = (props) => [
  getSubPaymentMethodsByClient(props),
  getAlltransactions(props)
];

export default compose(
  withAuthGuard({ toLoginURL: true }),
  injectIntl,
  withMembershipGuard,
  withPaymentStatus,
  withMembershipPurchased,
  connect(mapStateToProps, mapDispatchToProps),
  connectRequest(mapPropsToConfig),
)(ChangePlanPage);
